<template>
  <div>
    <FiltersAduanas
        :filtersView="filterView"
        :has-query-filters="!!queryFilters"
        :clear-query-filters="clear"
        v-on:filtros-aplicados="changeFilters"
    />
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FiltersAduanas from '@/febos/global/_vue/componentes/filtersLetty/aduanas/FiltersAduanas';
import ConfigReceiptsFiltersMixin
  from '@/febos/global/_vue/componentes/filtersLetty/aduanas/ConfigReceiptsFiltersMixin';
import { getShareableFilters } from '@/febos/chile/dnt/utils/fitlers';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';

export default {
  components: { FiltersAduanas },
  props: ['value', 'onChange', 'clear', 'defaultDate'],
  mixins: [ConfigReceiptsFiltersMixin],
  data() {
    const { name } = this.$route;
    return {
      view: name,
      currentFilters: '',
      queryFilters: this.$route.query.filters
    };
  },
  created() {
    this.getUsersCompany({
      empresaId: this.company.id,
      pagina: 1,
      filas: 9999,
      buscarInfoExtra: 'si',
      filtroInfoExtra: 'CARGO'
    });
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersCompany'
    ]),
    configuration() {
      return this.getFilterView(this.view);
    },
    filterView() {
      return this.getFilterView(this.view);
    }
  },
  methods: {
    ...mapActions('Empresas', [
      'getUsersCompany'
    ]),
    async changeFilters(filters, onMounted) {
      const defaultFilters = '';
      this.currentFilters = filters;
      const newFilters = filters !== ''
        ? `${defaultFilters}|${filters}`
        : defaultFilters;
      if (!onMounted) {
        const nonShareableFilters = [
          // TODO: agregar campo de busqueda de coincidencias
          ...(this.configuration.filtrosFijos || []).map((filterConfig) => filterConfig.campo)
        ];
        const queryFilters = getShareableFilters(newFilters, nonShareableFilters);
        updateSearchParams({ filters: queryFilters });
      }
      this.onChange(newFilters, onMounted);
    },
    clearQueryFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      this.$router.go();
    }
  }
};

</script>
